import React, { useCallback, useMemo } from 'react';
import { withStyles } from '@material-ui/styles';

import styles from '../styles';
import CustomIconButton from '../../../partials/tableCustomButtons/CustomIconButton';
import UserDetailDialog from './UserDetailDialog';

const TableActionButtons = ({ data, classes }) => {
  return (
    <div className={classes.actionCell}>
      <UserDetailDialog user={data}>
        <CustomIconButton
          iconTooltipIntlKey="USER_DETAILS"
          iconClassName="far fa-list"
        />
      </UserDetailDialog>
    </div>
  );
};

export default withStyles(styles)(TableActionButtons);
